class LazyVideo extends HTMLElement {
  constructor() {
    super()
    this.poster = this.querySelector('.lazy-video__poster')

    this.initObserver()
  }

  initObserver() {
    const loadVideo = (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        this.loadContent()
        observer.unobserve(entry.target)
      })
    }

    const intersectionObserver = new IntersectionObserver(loadVideo, {
      root: null,
      threshold: 0,
      rootMargin: '200px',
    })

    intersectionObserver.observe(this)
  }

  loadContent() {
    if (this.getAttribute('loaded')) return

    // 1. Add video content
    const content = this.querySelector('template')?.content.firstElementChild?.cloneNode(true)
    if (!content) return
    this.appendChild(content)

    // 2. Video Listeners
    this.addVideoListeners(content)

    // 3. Focus
    if (content instanceof HTMLElement && this.autoLoad === false) {
      content.focus()
    }

    // 4. Loaded attribute
    this.setAttribute('loaded', true)

    // 5. Force autoplay for Safari
    if (content instanceof HTMLVideoElement && content.getAttribute('autoplay')) content.play()
  }

  addVideoListeners(content) {
    const video = content.tagName === 'VIDEO' ? content : content.querySelector('video')

    if (video) {
      video.addEventListener('loadeddata', () => this.hidePoster())
      video.addEventListener('canplay', () => this.hidePoster())
    }
  }

  hidePoster() {
    this.poster?.classList.add('hidden')
  }
}

customElements.define('lazy-video', LazyVideo)